import { useEffect, useState } from "react";

export const useMatchMedia = (query: string) => {
    const [isMatch, setIsMatch] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const handleMediaChange = (event: MediaQueryListEvent) => {
            setIsMatch(event.matches);
        };

        setIsMatch(mediaQuery.matches);
        mediaQuery.addEventListener("change", handleMediaChange);

        return () => {
            mediaQuery.removeEventListener("change", handleMediaChange);
        };
    }, [query]);

    return isMatch;
};
